import { ProductClickForSearchPageParameters } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/Links/SearchProductTileBrandLinkProps";
import { useOnProductClickBase } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickBase";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import {
  SignUpType,
  SignUpElement,
  useTrackSignupModalOpenClick,
} from "@faire/retailer-visitor-shared/lib/popSignUp";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { trackEvent } from "@faire/web/common/trackEvent";
import { trackSeoSearchProductListProductLinkRefsClick } from "@faire/web-api--source/events/seo/click/searchProductListProductLinkRefs";
import { trackSignupModalOpenDiscoverProductTileClick } from "@faire/web-api--source/events/signup/click/modalOpenDiscoverProductTile";
import { trackSignupModalOpenSearchProductTileClick } from "@faire/web-api--source/events/signup/click/modalOpenSearchProductTile";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import kebabCase from "lodash/kebabCase";

export const productClickForSearchPageParametersILeanProductTileAdapter = (
  productTile: ILeanProductTile | undefined
): ProductClickForSearchPageParameters => {
  return {
    token: productTile?.product?.token,
    isPromoted: productTile?.product?.is_promoted,
    impressionId: productTile?.product?.impression_id,
    promotedBy: productTile?.product?.promoted_by,
    badgeList: productTile?.badge_list,
    bestImage: productTile?.best_image,
    images: productTile?.images,
    brandToken: productTile?.product?.brand_token,
  };
};

export const useOnProductClickForSearchPage = (
  params: ProductClickForSearchPageParameters
) => {
  const onProductClickBase = useOnProductClickBase(params);
  const productSearchString = useSearchPageProductSearchString();

  const isLoggedInRetailer = useIsLoggedInRetailer();
  const recordSignUpModalOpenCickEvent = useTrackSignupModalOpenClick();
  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
  return {
    onProductClick: () => {
      onProductClickBase();

      if (params.token && productSearchString) {
        trackEvent(
          `/search-click/${kebabCase(productSearchString)}/product/${
            params.token
          }`
        );

        trackSeoSearchProductListProductLinkRefsClick(
          params.token,
          productSearchString
        );
      }
      if (!isLoggedInRetailer) {
        recordSignUpModalOpenCickEvent(
          SignUpType.PRODUCT,
          SignUpElement.PRODUCT_GRID,
          `logged_out_product_tile`
        );
        if (isFromDiscoverURL) {
          trackSignupModalOpenDiscoverProductTileClick();
        } else {
          trackSignupModalOpenSearchProductTileClick();
        }
      }
    },
  };
};
